import { useEffect, useState } from "react";

type HealthResponse = {
  status: string;
  service: string;
  version: string;
  build?: string;
  env: string;
  timestamp: string;
};

export function Dashboard() {
  const [health, setHealth] = useState<HealthResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch("/api/health")
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json() as Promise<HealthResponse>;
      })
      .then(setHealth)
      .catch((e: unknown) => setError(e instanceof Error ? e.message : String(e)));
  }, []);

  return (
    <section className="card">
      <h2>Estado del backend</h2>
      {error && <p className="error">Error: {error}</p>}
      {!error && !health && <p>Comprobando...</p>}
      {health && (
        <dl>
          <dt>Servicio</dt>
          <dd>{health.service}</dd>
          <dt>Versión</dt>
          <dd>{health.version}</dd>
          {health.build && (
            <>
              <dt>Build</dt>
              <dd>{health.build}</dd>
            </>
          )}
          <dt>Entorno</dt>
          <dd>{health.env}</dd>
          <dt>Hora</dt>
          <dd>{health.timestamp}</dd>
        </dl>
      )}
    </section>
  );
}
